import { clampDay, compareIso, parseIso, toIso } from './dates.js'
import type { IsoDate } from './dates.js'
import type { ItemSchedule } from './types.js'

/**
 * Wyznacza terminy płatności pozycji, które wpadają w zakres [from, to].
 * Zakres jest domknięty obustronnie. Wynik jest posortowany rosnąco.
 */
export function generateDueDates(item: ItemSchedule, from: IsoDate, to: IsoDate): IsoDate[] {
  const lower = compareIso(from, item.startsOn) >= 0 ? from : item.startsOn
  const upper = item.endsOn !== null && compareIso(item.endsOn, to) < 0 ? item.endsOn : to
  if (compareIso(lower, upper) > 0) return []

  switch (item.cadence) {
    case 'monthly':
      return monthlyDueDates(item, lower, upper)
    case 'yearly':
      return yearlyDueDates(item, lower, upper)
    case 'one_off':
      return oneOffDueDates(item, lower, upper)
  }
}

function monthlyDueDates(item: ItemSchedule, lower: IsoDate, upper: IsoDate): IsoDate[] {
  if (item.dayOfMonth === null) throw new Error('Rytm miesięczny wymaga dnia miesiąca')
  const start = parseIso(lower)
  const end = parseIso(upper)
  const result: IsoDate[] = []

  let year = start.year
  let month = start.month
  while (year < end.year || (year === end.year && month <= end.month)) {
    const candidate = toIso(year, month, clampDay(year, month, item.dayOfMonth))
    if (compareIso(candidate, lower) >= 0 && compareIso(candidate, upper) <= 0) {
      result.push(candidate)
    }
    month += 1
    if (month > 12) {
      month = 1
      year += 1
    }
  }
  return result
}

function yearlyDueDates(item: ItemSchedule, lower: IsoDate, upper: IsoDate): IsoDate[] {
  if (item.monthOfYear === null) throw new Error('Rytm roczny wymaga miesiąca')
  if (item.dayOfMonth === null) throw new Error('Rytm roczny wymaga dnia miesiąca')
  const start = parseIso(lower)
  const end = parseIso(upper)
  const result: IsoDate[] = []

  for (let year = start.year; year <= end.year; year += 1) {
    const month = item.monthOfYear
    const candidate = toIso(year, month, clampDay(year, month, item.dayOfMonth))
    if (compareIso(candidate, lower) >= 0 && compareIso(candidate, upper) <= 0) {
      result.push(candidate)
    }
  }
  return result
}

function oneOffDueDates(item: ItemSchedule, lower: IsoDate, upper: IsoDate): IsoDate[] {
  if (item.dueDate === null) throw new Error('Pozycja jednorazowa wymaga daty')
  const inRange = compareIso(item.dueDate, lower) >= 0 && compareIso(item.dueDate, upper) <= 0
  return inRange ? [item.dueDate] : []
}
